import classNames from 'classnames'
import { CSSProperties } from 'react'
import { Editor, Node, Path } from 'slate'
import { ReactEditor, RenderElementProps, useSlate } from 'slate-react'

import { updateExpandBlock } from 'core-components/library/richTextEditor/helpers/slateHelper'

import styles from './ExpandBlockTitle.module.scss'

interface IProps {
  style: CSSProperties
}

export const ExpandBlockTitle = (props: RenderElementProps & IProps) => {
  const editor = useSlate()

  const path = ReactEditor.findPath(editor, props.element)
  const parentPath = Path.parent(path)
  const parentNode = Node.get(editor, parentPath)
  const isEmpty = Editor.isEmpty(editor, props.element)

  return (
    <summary
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      className={classNames(styles.header, parentNode['isOpen'] ? styles['header--opened'] : '')}
    >
      <div className={styles.title}>
        {props.children}
        <div
          contentEditable={false}
          className={classNames(styles.title__placeholder, {
            [styles['title__placeholder--hidden']]: !isEmpty,
          })}
        >
          Edit the title...
        </div>
      </div>
      <div
        onClick={() => updateExpandBlock(editor, parentPath, !parentNode['isOpen'])}
        className={styles.button}
        contentEditable={false}
      >
        <i
          className={classNames(
            styles.icon,
            parentNode['isOpen'] ? 'kbase kbase-minus' : 'kbase kbase-add'
          )}
        />
      </div>
    </summary>
  )
}
